import React, { useEffect, useState } from 'react';
import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  Label,
  Input,
  FormGroup,
  Form,
  Button,
  InputGroup,
  InputGroupText,
  ModalFooter, ModalHeader, ModalBody, Modal ,
} from 'reactstrap';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { directUrl, homePageUrl } from '../../../helpers/Constants';
import { requestApi } from '../../../request-api';
import { API_URL } from '../../../config';
import axios from 'axios';
import { userStore } from '../../../stores';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Triangle } from 'react-loader-spinner';

function ClientsEdit() {
  let [calendarValue, setCalenderValue] = useState(new Date());
  let [showCalender, setShowCalender] = useState(false);
  let [selectedDate, setSelectedDate] = useState('');
  let [company, setCompany] = useState([]);
   const [message, setMessage] = useState('');
   const [companyName, setCompanyName] = useState('');
   const [companyId, setCompanyId] = useState('');
   const [gstNum, setGstNum] = useState('');
   const [offcAddress, setOffcAddress] = useState('');
   const [pointOfCN, setPointOfCN] = useState('');
   const [phoneNum, setPhoneNum] = useState('');
   const [uploadedFileName, setUploadedFileName] = useState('');
   const [imageData, setImageData] = useState([]);
   let [formErrors, setFormErrors] = useState({});
  let [isSubmit, setIsSubmit] = useState(false);
  let [filename, setFilename] = useState("Choose File");
  let [loading, setLoading] = useState(false);
  let [modal, setModal] = useState(false);

  const [startDate, setStartDate] = useState(new Date());
  const { id } = useParams();
  const navigate = useNavigate()

  const successToast = (message) => toast.success(message, {
    position: "bottom-right"
});

const errorToast = (error) => toast.error(error, {
    position: "bottom-right"
});

  useEffect(() => {
    
      requestApi(`/auditor/company/getCompany/${id}`, {
        method: 'get',
      }).then((data) => {
        setCompany(data.data.getCompanyData);
        setCompanyName(data.data.getCompanyData.company_name)
        setCompanyId(data.data.getCompanyData.company_id);
        setGstNum(data.data.getCompanyData.gst_number);
        setOffcAddress(data.data.getCompanyData.office_address);
        setPointOfCN(data.data.getCompanyData.point_contact_name);
        setPhoneNum(data.data.getCompanyData.phone_number);
        setSelectedDate(data.data.getCompanyData.date_of_mou)
        let i,template = "";
        for(i=0;i<data.data.template.length;i++){
          console.log("length is ",data.data.template.length)
          if(i == data.data.template.length-1){
            template = template + data.data.template[i].template_id;
          }else{
            template = template + data.data.template[i].template_id + ',';
          }
          
        }
        console.log("data.data.template.length",template)
        setFilename(template);
        setImageData(template);      
      });
    
  },[]);
 
  const onFileChange = (event) => {
    event.preventDefault()
    setImageData(event.target.files);
    console.log("event.target.files[0]",event.target.files.length)
    file_select(event)
    if (event.target.files[0] == null) {
      setFilename("Choose File");
    } else {
    
      let i,filepath = "";
      for(i=0;i<event.target.files.length;i++){
        console.log("event.target.file[i].name",event.target.files[i].name)
        if(i == event.target.files.length-1)
        {
          filepath = filepath + event.target.files[i].name;
        }
        else{
          filepath = filepath + event.target.files[i].name + ',';
        }
      }
      
      setFilename(filepath);
  }
    
  };
  const file_select = (e) => {
    if(filename.name != null)
    {
      setFilename(filename.name);
    }
   
    else if (e.target.files[0] == null) {
      setFilename("Choose File");
    } else {
      const filepath = e.target.files[0].name;
      setFilename(filepath);
    }
   
  };

  useEffect(() => {
    setSelectedDate(
      `${calendarValue.getDate()}/${
        calendarValue.getMonth() + 1
      }/${calendarValue.getFullYear()}`
    );
  }, [calendarValue]);

    const submitForm = async (e) => {
      e.preventDefault()
      console.log("imageData------",imageData)
      let i;    
      setLoading(true)
      
      
        let arrayStatus =[]
        for(i=0;i<imageData.length;i++)
        {
          const formData = new FormData();
          formData.append("company_id", companyId);
          formData.append("company_name", companyName);
          let data = imageData[i];
          formData.append("file", data);
          formData.append("filename", data.name);
          const config = {
            headers: {
              "content-type": "multipart/form-data",
              Authorization: userStore.token || "",
            },
          };
          
         const CreateTemplate = await axios.post(
            `${API_URL}/auditor/template/createTemplate`,
            formData,
            config,
            {
              body: JSON.stringify({
                company_name: companyName,
                company_id: companyId,
                formData,
              }),
            }
          )
  
          arrayStatus.push(CreateTemplate.status)
          if(CreateTemplate.data.statusCode == 403){
            setLoading(false)
            errorToast(CreateTemplate.data.message)
            return 
          }
          console.log("CreateTemplate",imageData.length-1,i)
          if(i== imageData.length-1 && CreateTemplate.status == 200)
          {
            console.log("in company")
            requestApi(`/auditor/company/updateCompany/${id}`, {
              method: "post",
              body: JSON.stringify({
                company_name: companyName,
                company_id: companyId,
                gst_number: gstNum,
                date_of_mou: startDate,
                office_address: offcAddress,
                point_contact_name: pointOfCN,
                phone_number: phoneNum,
              }),
            }).then((data) => {
              console.log("data",data);
              if (data.statusCode === 200) {
                setLoading(false)
                successToast("Successfully created company");
                navigate(`${directUrl}auditor/clients`);
              }
              if (data.statusCode === 203) {
                setLoading(false)
                errorToast(data.message);
              }
              
              setLoading(false)
            })
            .catch((error) => {
              setLoading(false)
              errorToast(error.message)
              console.log(error);
            });
          }
              
        }
      // setLoading(true)
      // const formData = new FormData();
      // formData.append('file', imageData);
      // formData.append('filename', imageData.name);
      // formData.append('template_id', imageData.name);
      // formData.append('company_id', companyId);
      // console.log(formData, '---->', imageData);
      // const config = {
      //   headers: {
      //     'content-type': 'multipart/form-data',
      //     Authorization: userStore.token || '',
      //   },
      // };
      // return requestApi(`/auditor/company/updateCompany/${id}`, {
      //   method: 'post',
      //   body: JSON.stringify({
          // company_name: companyName,
          // company_id: companyId,
          // gst_number: gstNum,
          // date_of_mou: startDate,
          // office_address: offcAddress,
          // point_contact_name: pointOfCN,
          // phone_number: phoneNum,
      //   }),
      // }).then((companyData) => {
      //   console.log("yo buddy ",imageData.name)
      //   if(imageData.name){
      //     return axios.post(
      //       `${API_URL}/auditor/template/createTemplate`,
      //       formData,
      //       config,
      //       {
      //         body: JSON.stringify({
      //           company_id: companyData.data.company_id,
      //           template_id:imageData.name,
      //           formData,
      //         }),
      //       }
      //     );
      //   }
      //   })
      //   .then((data) => {
      //     console.log("updated company",data);
      //     setLoading(false)
      //     if(data){
      //       if (data.data.statusCode == 200) {
      //         successToast('Successfully created company');
      //          navigate(`${directUrl}auditor/clients`);
      //       }
      //       errorToast(data.data.message);
      //     }else if(imageData.name == undefined){
      //       console.log("hiee")
      //       successToast('Successfully created company');
      //        navigate(`${directUrl}auditor/clients`);
      //     }
         
      //   })
      //   .catch((error) => {
      //     setLoading(false)
      //     errorToast(error);
      //     console.log(error);
      //   });
    };

    const formValidation = () => {
      const errors = {};
      const gstrgx =
        /^([0-9]{2}[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})+$/;
      const mobRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
  
      if (companyName == "") {
        errors.companyname = "Company Name is required";
      }
      if (companyId == "") {
        errors.branchid = "Company ID is required";
      }
      if (gstNum == "") {
        errors.gstnumber = "GST Number is required";
      } else if (!gstrgx.test(gstNum)) {
        errors.gstnumber = "Invalid Number";
      }
      if (offcAddress == "") {
        errors.officeadd = "Office Address is required";
      }
      if (pointOfCN == "") {
        errors.pointofcontactname = "Point Of Contact Name is required";
      }
      if (phoneNum == "") {
        errors.pocnumber = "Phone Number is required";
      } else if (!mobRegex.test(phoneNum)) {
        errors.pocnumber = "Invalid Number";
      }
      if (imageData.length == 0) {
        errors.file = "File is required";
      }
  
      return errors;
    };

    const validateBanner = async (e) => {
      e.preventDefault();
      setIsSubmit(true);
      const validate = await formValidation()
      setFormErrors(validate);
      console.log("validate",validate)
      if (Object.keys(validate).length == 0) {
        if(imageData.name){
          requestApi(`/auditor/template/getTemplateById/${imageData.name}`,{
            method:'get'
          }).then((data)=>{
            console.log(data)
            if(data.statusCode == 200){
              customModal()
            }else if(data.statusCode == 404){
              submitForm(e)
            }
          })
        }else{
          submitForm(e)
        }
       
      }
    };
    const customModal = () => {
      console.log('method called', modal);
      setModal(!modal);
    };


  return (
    <section className="lyt-section">
      
      {
        loading?(
      <div className="loader-container"> 
        <div className="spinner"></div>
      </div>
        ):null
      }
      
      <Container fluid className="typ-container">
        <Breadcrumb className="bs-breadcrumb">
        <BreadcrumbItem>
            <NavLink to={`${directUrl}auditor/dashboard`}>Home</NavLink>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <NavLink to={`${directUrl}auditor/clients`}>Client</NavLink>
          </BreadcrumbItem>
          <BreadcrumbItem active>edit</BreadcrumbItem>
        </Breadcrumb>
        <div className="bs-card px-0">
          <div className="padding-area">
            <form className="bs-form" enctype="multipart/form-data">
              <Row>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="doj" className="mr-sm-2 cstm-label">
                    Company Name
                  </Label>
                  <Input
                    type="text"
                    disabled
                    name="company_name"
                    className="cstm-input"
                    placeholder="Enter Company Name"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                  />
                   <p className='error-message'>{formErrors.companyname}</p>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="doj" className="mr-sm-2 cstm-label">
                    Company ID
                  </Label>
                  <Input
                    type="text"
                    name="companyId"
                    className="cstm-input"
                    placeholder="Enter Company ID"
                    value={companyId}
                    disabled
                    contentEditable='false'
                    onChange={(e) => setCompanyId(e.target.value)}
                  />
                  <p className='error-message'>{formErrors.branchid}</p>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="doj" className="mr-sm-2 cstm-label">
                    GST Number
                  </Label>
                  <Input
                    type="text"
                    name="name"
                    className="cstm-input"
                    placeholder="Enter GST Number"
                    value={gstNum}
                    onChange={(e) => setGstNum(e.target.value)}
                  />
                   <p className='error-message'>{formErrors.gstnumber}</p>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="doj" className="mr-sm-2 cstm-label">
                    Date of MOU
                  </Label>
                  <div className="calender-area">
                    <DatePicker
                    disabled
                      value={selectedDate}
                      onChange={(date) => setStartDate(date)}
                      placeholderText="Enter Date of MOU"
                    />
                  </div>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="exampleText" className="cstm-label">
                    Office Address
                  </Label>
                  <Input
                    type="textarea"
                    name="text"
                    className="cstm-input"
                    value={offcAddress}
                    onChange={(e) => setOffcAddress(e.target.value)}
                    rows="5"
                    placeholder="Enter Office Address"
                  />
                  <p className='error-message'>{formErrors.officeadd}</p>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="doj" className="mr-sm-2 cstm-label">
                    Point of Contact Name
                  </Label>
                  <Input
                    type="text"
                    name="name"
                    value={pointOfCN}
                    onChange={(e) => setPointOfCN(e.target.value)}
                    className="cstm-input"
                    placeholder="Enter Point of Contact Name"
                  />
                  <p className='error-message'>{formErrors.pointofcontactname}</p>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="doj" className="mr-sm-2 cstm-label">
                    Phone Number
                  </Label>
                  <Input
                    type="text"
                    name="name"
                    value={phoneNum}
                    onChange={(e) => setPhoneNum(e.target.value)}
                    className="cstm-input"
                    placeholder="Enter Phone Number"
                  />
                   <p className='error-message'>{formErrors.pocnumber}</p>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="exampleEmail" className="mr-sm-2 cstm-label">
                    Upload List of Compliance template
                  </Label>
                  <div className="position-relative">
                    <Input
                      type="file"
                      name="file"
                      className="file-input"
                      placeholder={imageData}
                      id="file-input" 
                      multiple
                      onChange={onFileChange}
                    />
                    <InputGroup>
                      <Input placeholder={filename} className="mb-0"/>
                      <InputGroupText>Choose File</InputGroupText>
                    </InputGroup>
                    <p className='error-message'>{formErrors.file}</p>
                  </div>
                </Col>
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <button
                    className="bs-btn"
                    type="button"
                    onClick={(e) => validateBanner(e)}
                  >
                    SUBMIT
                  </button>
                </Col>
              </Row>
            </form>
            <Modal
                  isOpen={modal}
                  toggle={customModal}
                  size={'lg'}
                  centered={true}
                  className="bs-modal"
                >
                  <ModalHeader toggle={customModal}></ModalHeader>
                  <ModalBody toggle={customModal}>
                    <p className="title">
                      Template Already Exist,Do you want to replace?
                    </p>
                  </ModalBody>
                  <ModalFooter>
                    <button
                      onClick={(e)=>{submitForm(e)}}

                      className="bs-btn typ-delete min-width margin-right"
                    >
                      Replace
                    </button>{' '}
                    <button
                      onClick={customModal}
                      className="bs-btn typ-outline min-width"
                    >
                      Cancel
                    </button>
                  </ModalFooter>
                </Modal>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default ClientsEdit;
